import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {

  private _data:string;
  data$ = new Subject<any>();

  set data(data:any){
    this._data = data;
    this.data$.next(data);
  }

  getdata() {
    return this._data;
  }
}
